/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../modaldialogconfig.ts" />
/// <reference path="../bootstrapsize.ts" />
/// <reference path="../iconvertibletomodaldialogconfig.d.ts" />

module App.Common.Services {
	'use strict';

	export class ModalService {

		public static $inject = [
			'$uibModal',
			'app.common.services.errorHandlerService'];
		constructor(
			protected $uibModal: angular.ui.bootstrap.IModalService,
			protected errorHandler: Services.ErrorHandlerService
		) { }

		public modalWindow: angular.ui.bootstrap.IModalServiceInstance;

		public messageBox(
			title: string,
			message: string,
			outcomes: DialogOutcome[] = [DialogOutcome.ok],
			canDismissWithBackdropClick = false,
			canDismissWithEscapeKey = false,
			size = BootstrapSize.Medium) {
			return this.open(new MessageBoxConfig(title, message, outcomes, canDismissWithBackdropClick, canDismissWithEscapeKey, size));
		}

		public open<T extends IConvertibleToModalDialogConfig>(config: T): angular.ui.bootstrap.IModalServiceInstance {

			//Prevent modal dialogs appearing after a fatal error has been displayed
			if (this.errorHandler.errorShown) { return null; }

			var modalSettings = {} as angular.ui.bootstrap.IModalSettings;
			var modalConfig = config.toModalDialogConfig();

			modalSettings.animation = true;
			modalSettings.scope = modalConfig.scope;
			if (!modalConfig.canDismissWithBackdropClick) {
				modalSettings.backdrop = 'static';
			}
			modalSettings.keyboard = modalConfig.canDismissWithEscapeKey;
			modalSettings.controller = modalConfig.controller;
			if (modalSettings.controller) {
				modalSettings.controllerAs = 'vm';
				modalSettings.bindToController = true;
			}
			modalSettings.component = modalConfig.component;
			modalSettings.template = modalConfig.template;
			modalSettings.templateUrl = modalConfig.templateUrl;
			modalSettings.resolve = {
				config: config,
				modalConfig: modalConfig
			};
			
			switch (modalConfig.size) {
				case BootstrapSize.Large:
					modalSettings.size = 'lg';
					break;
				case BootstrapSize.Medium:
					modalSettings.size = 'md';
					break;
				case BootstrapSize.Small:
					modalSettings.size = 'sm';
					break;
				default:
					modalSettings.size = 'sm';
					break;
			}
			this.modalWindow = this.$uibModal.open(modalSettings);

			return this.modalWindow;
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.modalService', ModalService);
}